<template>
  <div class="alert alert-danger" :class="{'alert-danger': isError, 'alert-info': isInfo, 'alert-success': isSuccess, 'alert-warning': isWarning}">
    <slot name="message"></slot>
  </div>
</template>
<script>
export default {
  props: {
    messageType: {
      type: String,
      required: true
    }
  },
  computed: {
    isError: function () {
      return this.messageType === 'error'
    },
    isInfo: function () {
      return this.messageType === 'info'
    },
    isSuccess: function () {
      return this.messageType === 'success'
    },
    isWarning: function () {
      return this.messageType === 'warning'
    }
  }
}
</script>
